
export function getMailSubject(userData) {
  return `Query regarding telegram | Name: ${userData.name || userData.username || ""}`
}

export function getMailBody(creatorName, userData, pageUrl) {

  return `Hi creator,
I want to ask queries related to Telegram.
My query is: 

From: 
Name: ${userData.name || userData.username || ""}
Page link: ${pageUrl}
`
}